import { Component } from '../lib/ComponentBase';
import { simpleComponent } from '../lib/ComponentHelpers';
import type { DataComponent } from '../types/Components';

/**
 * An action component that signals an entity's intent to do nothing.
 * It bids with a very low priority.
 */
class Idle extends Component implements DataComponent {
  priority: number;

  constructor(data: { priority?: number } = {}) {
    super();
    this.priority = data.priority ?? 0;
  }
}

export default simpleComponent(Idle);
